import React from "react";
import { useNavigate } from "react-router";
import { ArrowLeft } from "lucide-react";

import VehicleForm from "../forms/VehicleForm";
import { Button } from "../../components/ui/button";

export default function AddVehiclePage() {
  const navigate = useNavigate();
  const goBack = () => navigate("/admin-management/others/vehicles");

  return (
    <div className="min-h-screen bg-slate-950 px-4 py-6 text-white">
      <header className="mb-6 flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          className="text-white hover:bg-white/10"
          onClick={goBack}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-white/60">
            Veículos
          </p>
          <h1 className="text-2xl font-semibold">Adicionar veículo</h1>
        </div>
      </header>
      <VehicleForm />
    </div>
  );
}
